import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BlockModuleService } from 'src/app/core/services/shared/block-module.service';

@Component({
  selector: 'app-block-module',
  templateUrl: './block-module.component.html',
  styleUrls: ['./block-module.component.css']
})
export class BlockModuleComponent implements OnInit, OnDestroy {

  title = 'Ya pasó la hora límite'
  subtitle = 'Puedes hacer la firma electrónica hasta las 7:50 p.m. del mismo día'
  typeIcon = 'pic-lock'
  buttonRight = 'Salir'
  showModal = false
  private destoy$ = new Subject<void>()
  private blockModuleService = inject(BlockModuleService)
  private route = inject(Router)

  ngOnInit(): void {
    this.blockModuleService.showModal$
    .pipe(takeUntil(this.destoy$))
    .subscribe(() => {
      this.showModal = true
    })
  }

  redirectToAuth(): void {
    this.route.navigate(['/auth'])
  }

  onSelectedOption(event: number): void {
    if (event === 1){
      this.showModal = false
      this.redirectToAuth()
    }
  }

  ngOnDestroy(): void {
    this.destoy$.next()
    this.destoy$.complete()
  }

}
